<template>
    <div>
        <Navbar />
        <BuyNow />
        <PageTitle pageTitle="İletişim" />
        <Contact pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Map pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import Contact from '../Contact/Contact'
import Map from '../Contact/Map'
import Footer from '../Layouts/Footer'
import BuyNow from '../Layouts/BuyNow'



export default {
    name: 'ContactPage',
    
    components: {
    Navbar,
    PageTitle,
    Contact,
    Map,
    Footer,
    BuyNow
},
}
</script>